/**
 * index.html paints a full-page loader before any script runs, and it stays until the first screen
 * with something to show. The app's own boot fallbacks render nothing while it is up, so the user
 * sees one spinner from the first paint to the shell instead of one per layer.
 */
export const BOOT_LOADER_ID = 'boot-loader';

export function isBootLoaderShowing(): boolean {
  return document.getElementById(BOOT_LOADER_ID) !== null;
}

/** Idempotent. The shell calls it, and so does every screen that can replace the shell (errors, the portal-only page). */
export function hideBootLoader(): void {
  document.getElementById(BOOT_LOADER_ID)?.remove();
}
